<template>
    <div>
        <div v-for="productListRecommendation in productListRecommendations"
             style="border: 5px solid #b2d630; border-top: none; "
        >
            <div>
                <h2 class="section-title product-list-recommendation-section-title" style="bottom: 18px;">
                    <span>{{ productListRecommendation.name }}</span>
                </h2>

                <vueper-slides
                    ref="productListRecommendationVslides"
                    class="product-list-recommendation-slides no-shadow mx-25px"
                    :class="{ 'cant-slide': !productListRecommendation.canSlide }"
                    fixed-height="750px"
                    :visible-slides="4"
                    slide-multiple
                    :gap="1"
                    :slide-ratio="1 / 2"
                    :dragging-distance="200"
                    :breakpoints="{
                        600: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '550px' },
                        770: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '650px' },
                        960: { visibleSlides: 2, slideMultiple: 2, fixedHeight: '600px' },
                        1000: { visibleSlides: 3, slideMultiple: 3, fixedHeight: '600px' },
                        1140: { visibleSlides: 3, slideMultiple: 3, fixedHeight: '580px' },
                        1300: { visibleSlides: 4, slideMultiple: 4, fixedHeight: '550px' },
                        1500: { visibleSlides: 4, slideMultiple: 4, fixedHeight: '600px' }
                    }"
                    :bullets="false"
                    :arrows="true"
                    style="margin: 35px;"
                >
                    <vueper-slide v-for="product in productListRecommendation.products"
                                  :key="product.id"
                                  :title="product.name"
                                  class="h-470px"
                    >
                        <template #content>
                            <div class="h-100">
                                <product-item
                                    :product="product"
                                    :is-plus-size="isPlusSize"
                                    container-class="h-100"
                                ></product-item>
                            </div>
                        </template>
                    </vueper-slide>
                </vueper-slides>
            </div>
        </div>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
    name: 'ProductListRecommendations',
    components: {
        VueperSlides,
        VueperSlide,
    },

    props: {
        productListRecommendations: {
            type: Array,
            required: false,
            default: () => [],
        },
        isPlusSize: {
            type: Boolean,
            default: () => false,
        },
    },

    mounted() {
        for (let i = 0; i < this.productListRecommendations.length; i++) {
            this.productListRecommendations[i].canSlide = this.$refs.productListRecommendationVslides[i].canSlide
        }
    },
}
</script>

<style lang="scss" scoped>
.cant-slide {
    .vueperslides__track-inner {
        justify-content: center;
    }
}

.product-list-recommendation-slides {
    ::v-deep .listitem {
        width: 100% !important;
    }
}

.product-list-recommendation-section-title::before {
    border-top: 5px solid #b2d630 !important;
}

</style>
